function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M3.333 7.5V15c0 .46.373.833.834.833h11.666c.46 0 .834-.373.834-.833V7.5a.833.833 0 00-.834-.833h-2.357L11.81 5H8.19L6.524 6.667H4.167a.833.833 0 00-.834.833zm2.5-2.5l1.179-1.179a1.667 1.667 0 011.178-.488h3.62c.442 0 .866.176 1.178.488L14.167 5h1.666a2.5 2.5 0 012.5 2.5V15a2.5 2.5 0 01-2.5 2.5H4.167a2.5 2.5 0 01-2.5-2.5V7.5a2.5 2.5 0 012.5-2.5h1.666zm-1.5 6.667l2.5-2.5 2.5 2.5h-1.69a2.487 2.487 0 003.958 1.057l1.146 1.211a4.154 4.154 0 01-6.83-2.268H4.333zM15.833 10l-2.5 2.5-2.5-2.5h1.529a2.487 2.487 0 00-3.899-1.124c-.021.017-1.04-1.302-1.04-1.302A4.154 4.154 0 0114.086 10h1.747z"
});

var SvgCameraRefresh = function SvgCameraRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _ref);
};

export default SvgCameraRefresh;